import React from 'react';
import PropTypes from 'prop-types';
import styles from './Datadog.module.scss';
export const DataDogMask = ({ children }) => {
    return (<div data-dd-privacy="mask" className={styles.mfeDatadogMask}>
            {children}
        </div>);
};
DataDogMask.propTypes = {
    children: PropTypes.any,
};
